import { useCallback } from 'react';
import rootStore from '../../RootStore';
import GQCountrySelect from '../GQCountryMode/GQCountrySelect';
import { useNavigate } from 'react-router-dom';
import { VIEW } from 'interfaces';

const CountryGraphSelectCountry = () => {
    const navigate = useNavigate();

    const onSelectCountry = useCallback((id: number) => {
        rootStore.countryStore.currentStore.overrideValues(id);
        navigate(`/${VIEW.COUNTRY_GRAPH}`);
    }, [navigate]);

    return <GQCountrySelect onCountrySelected={onSelectCountry} />;
};

export default CountryGraphSelectCountry;
